// @flow
/** Collection of helper functions and types used for internal purposes only. Not to be exported outside this package. */

export type DirectionValue<T> = T | DirectionObject<T>;
// Flow bug: Spreading the shape of an exact type loses the shape. Fork the shape into a separate type for now
export type OptionalDirectionObject<T> = {| left?: T, top?: T, right?: T, bottom?: T |};
export type DirectionObject<T> = {| left: T, top: T, right: T, bottom: T |};
export type Direction = 'left' | 'top' | 'right' | 'bottom';

export type Pair<T> = {|
  top: T,
  left: T,
|};
export type Position = Pair<number>;

export const directionObject = (value: DirectionValue<*>) =>
  typeof value === 'object' ? value : { left: value, right: value, top: value, bottom: value };

export const defaultPosition = { top: 0, left: 0 };
